module.exports = __webpack_public_path__ + "static/media/edulai.e23862c8.png";